import { Texture } from 'pixi.js';
import { Emitter} from 'pixi-particles';
import levelSelectParticle from "../../data/particles-level-select.json";

export class SwirlTrailParticle extends PIXI.ParticleContainer {

    constructor(){
        super(100, {
            scale: true,
            alpha: true
        });
        this.particleTexture = new Texture.from("level-select-particle");

        this.emitter = new Emitter(
            this,
            this.particleTexture,
            levelSelectParticle
        )

        this.emitter.emit = true;
        this.emitter.autoUpdate = true;
    }

    play(){
        this.emitter.emit = true;
    }

    stop(){
        this.emitter.autoUpdate = false;
        this.emitter.emit = false;
    }
}
